// react
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, graphql, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';
import { checkAuth, logout } from '../../action/AuthAction';
import { addNotification, retrieveNotifications, hideNotification, NOTIFICATION_TYPE } from '../../action/NotificationAction';
import { getLoginUrl } from '../../common/Navigation';
import { LocalStorageKey } from '../../common/Definitions';

import LoadingView from '../../component/Common/Misc/LoadingView';
import ErrorAlert from '../../component/Common/Alert/ErrorAlert';
import InfoAlert from '../../component/Common/Alert/InfoAlert';
import SuccessAlert from '../../component/Common/Alert/SuccessAlert';
import WarningAlert from '../../component/Common/Alert/WarningAlert';

// queries
import GET_CURRENT_USER from '../../graphql/query/user/getCurrentUser';

import Routes from './Routes';

class App extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname);

    this.props.checkAuth();
    if (this.props.Auth.isLoggedIn) {
      this.props.retrieveNotifications();
    }
  }

  componentDidUpdate(prevProps) {
    // Refetch User on Log In
    if (!prevProps.Auth.isLoggedIn && this.props.Auth.isLoggedIn) {
      this.props.user.refetch();
      this.props.retrieveNotifications();
    }
    // Refetch Notifications if added/hidden
    if (this.props.Auth.isLoggedIn &&
      ((!prevProps.Notifications.added && this.props.Notifications.added) || (!prevProps.Notifications.hidden && this.props.Notifications.hidden))) {
      this.props.retrieveNotifications();
    }
  }

  onLogout = () => {
    this.props.logout(() => {
      this.props.history.push(getLoginUrl());
      this.props.client.clearStore();
    });
  }

  onReload = () => {
    localStorage.removeItem(LocalStorageKey.UPDATE_VERSION);
    window.location.reload();
  }

  render() {
    if (this.props.user.loading ||
      this.props.user.networkStatus === 4 ||
      this.props.Auth.isLoading) {
      return <LoadingView />;
    }

    // Notifications
    let notificationsPane;
    if (this.props.Notifications.notifications && this.props.Notifications.notifications.length) {
      notificationsPane = (
        <div className="notifications-pane">
          {this.props.Notifications.notifications.map(n => {
            switch (n.type) {
              case NOTIFICATION_TYPE.INFO:
                return <InfoAlert onClose={() => this.props.hideNotification(n.id)} text={n.notification} />;
              case NOTIFICATION_TYPE.SUCCESS:
                return <SuccessAlert onClose={() => this.props.hideNotification(n.id)} text={n.notification} />;
              case NOTIFICATION_TYPE.ERROR:
                return <ErrorAlert onClose={() => this.props.hideNotification(n.id)} text={n.notification} />;
              default:
                return <WarningAlert onClose={() => this.props.hideNotification(n.id)} text={n.notification} />;
            }
          })}
        </div>
      );
    }
    
    return (
      <div className="app ios-scroll">
        {notificationsPane}
        <Routes
          isLoggedIn={this.props.Auth.isLoggedIn}
          onLogout={this.onLogout}
          user={this.props.user.user}
          userRefetch={this.props.user.refetch}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  Auth: state.Auth,
  Notifications: state.Notifications,
});

const mapDispatchToProps = dispatch => ({
  checkAuth: () => {
    dispatch(checkAuth());
  },
  logout: (callback) => {
    dispatch(logout(callback));
  },
  addNotification: (id, notification, type) => {
    dispatch(addNotification(id, notification, type));
  },
  hideNotification: (id) => {
    dispatch(hideNotification(id));
  },
  retrieveNotifications: () => {
    dispatch(retrieveNotifications());
  },
});

const withCurrentUser = graphql(GET_CURRENT_USER, {
  name: 'user',
  notifyOnNetworkStatusChange: true,
});

export default withRouter(withApollo(compose(
  withCurrentUser,
  connect(mapStateToProps, mapDispatchToProps)
)(App)));
